import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import CurrencyCard from "./CurrencyCard";
import cashIcon from "../../../images/gameplay_ui/icons/cash_icon.svg";
export default class CardWithCost extends React.Component{

    render() {
        let mainStyle = {
            paddingBottom: "5px"
        }
        let imageStyle = {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: this.props.image ? "5px" : "3px"
        }
        let content = [];
        if(this.props.image){
            content.push(<img key={'iiimg'} src={this.props.image} alt={"icon"}/>)
        }
        content.push(<CurrencyCard key={'currency'} icon={cashIcon} value={this.props.cost ?? 1000000} fontSize={14} textColor={"black"}  size={20} style={{
        paddingTop: "5px"}
        }/>)
        content = <div style={imageStyle}>{content}</div>;
        return <div style={mainStyle}>
            <GameWindowHeader width={this.props.width ?? 118}
                              height={this.props.headerHeight ?? 30}
                              icon={this.props.icon}
                              title={this.props.title}
                              iconSize={this.props.iconSize ?? 20}
                              fontSize={12}
                              fontWeight={"bold"}
                              positionTop={10}
                              positionLeft={this.props.icon ? this.props.posL !== undefined ? this.props.posL : -5 : 0}
                              colorStart={this.props.colors[0]}
                              colorEnd={this.props.colors[1]}
            />
            <GameWindowBg width={this.props.width ?? 80} height={this.props.height ?? 95} value={content}/>
        </div>
    }
}
